export function isSafeInternalLoginRedirectPath(path) {
  if (!path || typeof path !== "string") {
    return false;
  }

  if (!path.startsWith("/") || path.startsWith("//") || path.includes("://")) {
    return false;
  }

  if (
    path.startsWith("/auth/login")
    || path.startsWith("/auth/logout")
    || path.startsWith("/auth/register")
  ) {
    return false;
  }

  return true;
}

export function buildLoginReturnPath(location) {
  if (!location) {
    return "/";
  }

  const { pathname = "/", search = "", hash = "" } = location;
  return `${pathname}${search}${hash}`;
}

export function resolvePostLoginRedirectPath({ location, fallback = "/" } = {}) {
  const fromState = location?.state?.from;
  if (typeof fromState === "string" && isSafeInternalLoginRedirectPath(fromState)) {
    return fromState;
  }

  const redirectHash = location.hash?.replace("#", "") || "";
  if (redirectHash) {
    const hashPath = redirectHash.startsWith("/") ? redirectHash : `/${redirectHash}`;
    if (isSafeInternalLoginRedirectPath(hashPath)) {
      return hashPath;
    }
  }

  return fallback;
}
